<script>
import mixin from '@/plans/mx/shopping-cart';
import { map, orderBy, sortBy } from 'lodash';
import { pageConfig } from '@/common/service/page-config';
import planCommon from '@/plans/LARGE_MEETING/mixin';
import { computedLargeMeetingPlans } from '@/common/service/computers/plans/large-meeting';
import { mapState } from 'vuex';
import { getNeedFilterCapacityList } from '@/common/product';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';

export default {
  mixins: [mixin, planCommon],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    planList() {
      return this.planMapFlat.filter((p) => p.type === this.planType);
    },
    boughtCurrentPlans() {
      // todo also can use for webinar
      return computedLargeMeetingPlans(this.boughtPlans);
    },
    allCapacityOrderList() {
      let allCapacityOrderList = [...new Set(orderBy(map(this.planList, this.capacityKey)))].filter((capacity) =>
        this.supportCapacity.includes(capacity),
      );
      // for edit
      if (this.$context.is.add2cart && this.boughtCurrentPlans.length) {
        allCapacityOrderList = allCapacityOrderList.filter(
          (capacity) => !map(this.boughtCurrentPlans, this.capacityKey).includes(capacity),
        );
      }
      allCapacityOrderList = allCapacityOrderList.filter(
        (capacity) => !getNeedFilterCapacityList(this.getCurrentBasePlanInfo?.plans).includes(capacity),
      );
      return allCapacityOrderList;
    },
    boughtCapacityList() {
      return [...new Set(map(this.boughtCurrentPlans, this.capacityKey))].filter((capacity) =>
        this.supportCapacity.includes(capacity),
      );
    },
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      let plans = this.mx_plans;
      if (this.$context.is.add2cart) {
        plans = this.mx_plans.filter((x) => this.boughtPlans.find((y) => y.plan_code !== x.plan_code)); // exclude bought plans
      } else if (this.$context.is.edit && this.allCapacityOrderList.length === this.boughtCapacityList.length) {
        plans = this.mx_plans.filter((x) => x.category === pageConfig?.subPlan);
      }
      return (
        <div class="opc-cart-item">
          {this.mx_main_title(this.$t('billing.large_meeting.title'), undefined, plans[0]?.parent_category)}
          {sortBy(plans, 'participants').map((plan) => {
            return (
              <div>
                {this.mx_subTitle(
                  `${plan.participants} ${this.$t('billing.participants')}`,
                  <AltProratedPlanPrice type={plan.type} code={plan.plan_code}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
                  plan?.plan_code,
                )}
                {this.mx_discount(plan.plan_code)}
                <AltProratedPlanUser type={plan.type} code={plan.plan_code}>{this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.license'))}</AltProratedPlanUser>
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanPeriod type={plan.type} code={plan.plan_code} />
                {this.mx_edit(plan)}
                {this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
    $renderTip() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
